"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTenantLanguageParams = void 0;
var _zodUtils = require("@ori/zod-utils");
/**
 * Parses the tenant and language query parameters.
 *
 * @param params  Next.js query parameters object.
 * @returns An object containing the parsed tenant and language.
 * @throws Error if the tenant or language query parameter is missing.
 */
const parseTenantLanguageParams = params => {
  if (!params) {
    throw new Error('Params are required');
  }
  const {
    tenant,
    language
  } = params;
  const validatedTenant = (0, _zodUtils.validateTenant)(tenant);
  if (!validatedTenant) {
    throw new Error('Tenant query param is required');
  }
  const validatedLanguage = (0, _zodUtils.validateLanguage)(language);
  if (!validatedLanguage) {
    throw new Error('Language query param is required');
  }
  return {
    tenant: validatedTenant,
    language: validatedLanguage
  };
};
exports.parseTenantLanguageParams = parseTenantLanguageParams;
